<template>
  <ItemsQuestion
    v-if="parkOffersAcceleration"
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
  ></ItemsQuestion>
</template>

<script>
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'AccelerationProgramItemsQuestion',
    components: { ItemsQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    methods: {
      isValid () {
        if (!this.parkOffersAcceleration) {
          return true
        }
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    },
    computed: {
      parkOffersAcceleration () {
        return ParkPrograms.has(ParkPrograms.ACCELERATION, this.quizAnswers)
      }
    },
    watch: {
      parkOffersAcceleration: {
        immediate: true,
        handler () {
          if (!this.parkOffersAcceleration) {
            this.$emit('answerUpdated', {...this.answer, value: null})
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AccelerationProgramItemsQuestion.vue?22e84b9a